import type { TBCustomer } from "@/types/data";
import { loadingStates } from "@arenko-group/arenko-ui/dist/enums/loading.enum";
import {
  fetchWrapper,
  HttpError,
} from "@arenko-group/arenko-ui/dist/services/fetchWrapper.service";

export const handleHttpError = (error: unknown) => {
  const status = error instanceof HttpError ? error.status : undefined;
  return status === 401 ? loadingStates.authError : loadingStates.errored;
};

export const getCustomerName = async (
  customerId: string,
  defaultCustomerName: string
) => {
  try {
    const customer: TBCustomer = await fetchWrapper<TBCustomer>(
      `/api/customer/${customerId}`,
      { useXAuthHeader: true }
    );
    return String(customer.title);
  } catch {
    return defaultCustomerName;
  }
};
